// function dataURLtoBlob(dataurl) {
//     var arr = dataurl.split(','),
//         mime = arr[0].match(/:(.*?);/)[1],
//         bstr = atob(arr[1]),
//         n = bstr.length,
//         u8arr = new Uint8Array(n);
//     while (n--) {
//         u8arr[n] = bstr.charCodeAt(n);
//     }
//     return new Blob([u8arr], {
//         type: mime
//     });

// }

// function blobToFile(theBlob, fileName) {
//     theBlob.lastModifiedDate = new Date();
//     theBlob.name = fileName;
//     return theBlob;
// }





//压缩图片
function compressImg(file) {

    var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
    var read = new FileReader();
    read.readAsDataURL(file);
    return new Promise(function (resolve, reject) {
        read.onload = function (e) {
            var img = new Image();
            img.crossOrigin = "Anonymous";
            img.src = e.target.result;
            img.onload = function () {
                //默认按比例压缩
                var w = this.width,
                    h = this.height;
                //生成canvas
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                var base64;
                // 创建属性节点
                canvas.setAttribute("width", w);
                canvas.setAttribute("height", h);
                ctx.drawImage(this, 0, 0, w, h);

                //如果图片小于一兆 那么不执行压缩操作
                if (fileSize < 1) {
                    base64 = canvas.toDataURL('image/jpeg', 1);
                }
                if (1 < fileSize < 5) {
                    base64 = canvas.toDataURL('image/jpeg', 0.5);
                }
                if (fileSize > 5) {
                    base64 = canvas.toDataURL('image/jpeg', 0.3);
                }

                // base64 = canvas.toDataURL(file['type'], 0.5);

                resolve(base64)
            };
        };
    })
};

//结尾处将该方法暴露出来供外部调用
module.exports = {
    compressImg
}